export default __webpack_public_path__ + "static/media/IMG_1879.8c56db3d.jpeg";